import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class HowItWorksSolverPageService {
	getSolverData(language) {
		return axios
			.post(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/solver?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new HowItWorksSolverPageService();
